import { render } from "./IconOverlay.vue?vue&type=template&id=f4e45854&scoped=true"
import script from "./IconOverlay.vue?vue&type=script&lang=js"
export * from "./IconOverlay.vue?vue&type=script&lang=js"

import "./IconOverlay.vue?vue&type=style&index=0&id=f4e45854&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e45854"]])

export default __exports__